export const MARKETING_CONSENT_STORAGE_KEY = 'sazeo-marketing-cookie-consent';
export const ANALYTICS_CONSENT_EVENT = 'sazeo:analytics-consent-changed';

export type AnalyticsConsentState = {
  analytics: boolean;
  marketing: boolean;
};

export function readAnalyticsConsent(
  storage: Storage | null | undefined = typeof window === 'undefined' ? null : window.localStorage,
  key = MARKETING_CONSENT_STORAGE_KEY,
): AnalyticsConsentState | null {
  if (!storage) return null;

  try {
    const raw = storage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<AnalyticsConsentState>;
    return {
      analytics: parsed.analytics === true,
      marketing: parsed.marketing === true,
    };
  } catch {
    return null;
  }
}

export function hasAnalyticsConsent(
  storage: Storage | null | undefined = typeof window === 'undefined' ? null : window.localStorage,
  key = MARKETING_CONSENT_STORAGE_KEY,
): boolean {
  return readAnalyticsConsent(storage, key)?.analytics === true;
}

export function dispatchAnalyticsConsentChange(
  consent: AnalyticsConsentState,
  target: Window = window,
): void {
  target.dispatchEvent(
    new CustomEvent<AnalyticsConsentState>(ANALYTICS_CONSENT_EVENT, {
      detail: consent,
    }),
  );
}
